exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".buttons {\n  margin-top: 20px;\n  float: right; }\n\nmd-select {\n  margin-top: 15px; }\n\ninput {\n  color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/shared/add-user/add-user.component.scss
// module id = 1279
// module chunks = 0